import { ActionType } from "typesafe-actions";

import * as actions from "./actions";

export type FeedbacksAction = ActionType<typeof actions>;

export enum FeedbacksActionTypes {
  TABLE_FETCH_REQUEST = "@Feedbacks/TABLE_FETCH_REQUEST",
  TABLE_FETCH_SUCCESS = "@Feedbacks/TABLE_FETCH_SUCCESS",
  TABLE_FETCH_ERROR = "@Feedbacks/TABLE_FETCH_ERROR",

  CHART_FETCH_REQUEST = "@Feedbacks/HART_FETCH_REQUEST",
  CHART_FETCH_SUCCESS = "@Feedbacks/CHART_FETCH_SUCCESS",
  CHART_FETCH_ERROR = "@Feedbacks/CHART_FETCH_ERROR",
}

export interface ChartItem {
  date: string;
  csi: number;
  ssr: number;
  speed: number;
  price: number;
  convenience: number;
}

export interface FeedbackItem {
  id: string;
  createdAt: string;
  marker: string;
  text: string;
}

export interface FeedbacksState {
  count: number;
  items: FeedbackItem[];
  dataIsLoading: boolean;

  chartItems: ChartItem[];
  chartDataIsLoading: boolean;
}
